export default {"src":"https://web.cdn.greenlight.com/2.1257.0/_next/static/media/x-icon.0ae09442.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};